module.exports = __webpack_public_path__ + "img/nav-thumbnail-infinite-hyrule.c67765a5.png";